"use client";
import { usePathname } from "next/navigation";
import { type ReactNode, useCallback, useEffect, useState } from "react";
import BurgerIcon from "../../BurgerIcon";
import s from "./ClassicMobileNav.module.scss";

export interface ClassicMobileNavProps {
  menu: ReactNode;
  multiLineNav?: boolean;
}

export default function ClassicMobileNav({ menu }: ClassicMobileNavProps) {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const handleOpen = useCallback(() => {
    setOpen((o) => !o);
  }, []);

  return (
    <>
      <BurgerIcon open={open} onClick={handleOpen} color="light" />
      {open && <nav className={s.nav}>{menu}</nav>}
    </>
  );
}
